import { createContext, useContext } from 'react';

export const PacketBuilderContext = createContext();

export const usePacketBuilderContext = () => useContext(PacketBuilderContext);
